import { LABEL_ALIGNMENT } from '../constants.js';
import { LabelAlignment, LabelCoords } from '../types/range-legend.internal.js';

const DEFAULT_POSITION_X_VERTICAL = 12;

/**
 * Returns the coordinates of the label, depending on the type of alignment,
 * positioned in a vertical layout.
 */
export const getVerticalLabelPosition = (
  labelHeight: number,
  itemStartPosition: number,
  itemEndPosition: number,
  alignment: LabelAlignment,
): Required<LabelCoords> => {
  const labelPositionX = DEFAULT_POSITION_X_VERTICAL;

  switch (alignment) {
    case LABEL_ALIGNMENT.Start:
      return {
        x: labelPositionX,
        y: Math.floor(itemStartPosition + labelHeight),
      };
    case LABEL_ALIGNMENT.End: {
      return {
        x: labelPositionX,
        y: itemEndPosition,
      };
    }
    case LABEL_ALIGNMENT.Center: {
      return {
        x: labelPositionX,
        y: Math.floor(itemEndPosition + labelHeight / 2),
      };
    }
  }
};
